import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let SurveyAnswers = {
    selector: "vcSurveyAnswers",
    templateUrl: "/angular/components/survey/survey-answers.component.html",
    bindings: {
        question: "=",
    },
    controller: class SurveyAnswersController {
        // * bindings for typescript compiler *
        public question: any;
        // ************************************

        private $scope: any;
        public __env: any;
        private dialog: DialogUtils;

        constructor($scope: any, __env: any, DialogUtils: DialogUtils) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.__env = __env;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        openViewHouseOccupantDialog(hoid: number, ev: any): void {
            this.dialog.show({
                component: "vc-view-house-occupant",
                targetEvent: ev,
                scope: this.$scope,
                skipHide: true,
                clickOutsideToClose: true,
                locals: {
                    selectedHoid: hoid,
                },
                ariaLabel: "View Person",
                size: "large",
            });
        }

        openViewHouseDialog(hid: number, ev: any): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }
    },
};

angular.module("survey", []).component(SurveyAnswers.selector, SurveyAnswers);
